import React, { useCallback, useEffect, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../utils/firebase';
import { useNavigate, useOutletContext } from 'react-router-dom'
import { signInWithGoogle } from '../../../utils/firebase';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Styles from '../../../styles/Forms.module.css'
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormSide from '../../../images/form_side.webp'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Stack from '@mui/material/Stack';
import { isValidEmail } from '../../../utils/strings';
import GoogleLogo from '../../../images/google_logo.webp'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import EasySnackBar from '../../../components/EasySnackBar';

import logo from '../../../images/big_logo.webp'

export default function Login() {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()

    const onLogin = useCallback((e) => {
        if (isValidEmail(email)) {
            signInWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    navigate("/admin/app")
                })
                .catch((error) => {
                    if (error.code === 'auth/wrong-password') {
                        setErrorMessage('Contraseña incorrecta')
                    } else if (error.code === 'auth/user-not-found') {
                        setErrorMessage('No existe una cuenta con el email ingresado')
                    } else {
                        setErrorMessage('Algo salió mal, intenta nuevamente mas tarde')
                    }
                });
        }
    }, [auth, email, password, navigate])

    useEffect(() => {
        if (userAuth) {
            navigate("/admin/app")
        }
    }, [userAuth, navigate])

    if (userAuth === undefined) {
        return <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>

    } else {
        return (
            <>
                <div className={Styles.container}>
                    <Stack
                        direction='row'
                        flexWrap='wrap'
                        justifyContent='center'
                        className={Styles.content}
                    >
                        <Stack spacing={2} className={Styles.form}>
                            <img src={logo} onClick={() => navigate('/')} className={Styles.logo} />
                            <Typography className={Styles.title}>
                                Ingresar
                            </Typography>

                            <TextField
                                label="Email"
                                variant="outlined"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                error={!isValidEmail(email) && email !== ''}
                                required
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        onLogin()
                                    }
                                }}
                            />

                            <FormControl required variant="outlined">
                                <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            onLogin()
                                        }
                                    }}
                                    required
                                    type={showPassword ? 'text' : 'password'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={setShowPassword.bind(this, prev => !prev)}
                                                onMouseDown={e => e.preventDefault()}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Contraseña"
                                />
                            </FormControl>

                            <Typography variant='body1' className={Styles.actionText} onClick={() => navigate('/admin/recover')}>
                                <b>Olvidaste tu contraseña?</b>
                            </Typography>

                            <Button variant="contained" onClick={() => onLogin()}>Ingresar</Button>

                            <Divider>Tambien puedes</Divider>

                            <Button variant="outlined" onClick={() => signInWithGoogle()}>
                                <img src={GoogleLogo} className={Styles.loginMethodLogo} alt='google logo' />
                                Ingresar con Google
                            </Button>

                            <Typography variant='body1'>
                                No tienes una cuenta? <span
                                    className={Styles.actionText}
                                    onClick={() => navigate('/admin/signup')}>
                                    Crea una nueva
                                </span>
                            </Typography>

                        </Stack>
                        <div className={Styles.sideImage} style={{ backgroundImage: 'url(' + FormSide + ')' }}></div>
                    </Stack>
                </div>

                <EasySnackBar
                    severity='error'
                    key='1'
                    message={errorMessage}
                    setMessage={setErrorMessage}
                />
            </>
        )
    }
}